import React, { useState, useEffect } from "react";
import { Form, Input, Checkbox, Row, Col } from "antd";
import { Formik, Field } from "formik";
import { FormInputField } from "../../../../Components/FormInputField/FormInputField";

function ChangePassword({
  passwordError,
  updatePasswordObj,
  toggleUpdateDisability,
}) {
  const [validationError, setValidationError] = useState({});
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [logoutAllDevicesCheckbox, setLogoutAllDevicesCheckbox] =
    useState(false);
  const [oldPasswordEmptyError, setOldPasswordEmptyError] = useState(true);
  const [newPasswordError, setNewPasswordError] = useState(true);
  const [matchPasswordError, setMatchPasswordError] = useState(true);
  const validatedClassName = "update-password-checkbox-checked";
  const inValidatedClassName = "update-password-checkbox-unchecked";

  useEffect(() => {
    toggleUpdateDisability(
      oldPasswordEmptyError || newPasswordError || matchPasswordError
    );
  }, [oldPasswordEmptyError, newPasswordError, matchPasswordError]);
  useEffect(() => {
    updatePasswordObj({
      newPassword: password,
      oldPassword: oldPassword,
      oldPasswordIncluded: true,
      logout_all_devices: logoutAllDevicesCheckbox,
    });
  }, [logoutAllDevicesCheckbox]);
  const onOldPasswordChanged = (e) => {
    let pass = e.target.value;
    setOldPasswordEmptyError(false);
    if (e.target.value.length === 0) {
      setOldPasswordEmptyError(true);
    }
    setOldPassword(pass);
    updatePasswordObj({
      newPassword: password,
      oldPassword: e.target.value,
      oldPasswordIncluded: true,
      logout_all_devices: logoutAllDevicesCheckbox,
    });
  };
  const onPasswordChanged = (e) => {
    let pass = e.target.value;
    setNewPasswordError(false);
    setPassword(pass);
    setValidationError({
      isMinimumLimitMet: pass.length >= 8,
      isOneLowerCharacterLimitMet: /[a-z]/.test(pass),
      isOneUpperCharacterLimitMet: /[A-Z]/.test(pass),
      isOneSpecialCharacterLimitMet:
        /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(pass),
      isOneNumberLimitMet: /[0-9]/.test(pass),
      doesPasswordMatch: pass === confirmPassword && confirmPassword !== "",
    });
    if (
      !(
        pass.length >= 8 &&
        /[a-z]/.test(pass) &&
        /[A-Z]/.test(pass) &&
        /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(pass) &&
        /[0-9]/.test(pass)
      )
    ) {
      setNewPasswordError(true);
    }
    setMatchPasswordError(false);
    if (!(pass === confirmPassword && confirmPassword !== "")) {
      setMatchPasswordError(true);
    }
    updatePasswordObj({
      newPassword: e.target.value,
      oldPassword: oldPassword,
      oldPasswordIncluded: true,
      logout_all_devices: logoutAllDevicesCheckbox,
    });
  };
  const onConfirmPasswordChanged = (e) => {
    let pass = e.target.value;
    setMatchPasswordError(false);
    setConfirmPassword(pass);
    setValidationError({
      ...validationError,
      doesPasswordMatch: pass === password && password !== "",
    });
    if (!(pass === password && password !== "")) {
      setMatchPasswordError(true);
    }
  };

  try {
    Object.keys(validationError).forEach(function (key) {
      if (!validationError[key]) {
        throw "valiation not met";
      }
    });
  } catch (e) {}
  return (
    <>
      <div style={{ textAlign: "left", color: "#0000008a" }}>
        Please set your new password according to the mentioned criteria
      </div>
      <Formik
        initialValues={{ old_password: "", password: "", confirm_password: "" }}
        validateOnChange={false}
        validateOnBlur={false}
        render={(formikProps) => {
          return (
            <>
              <Form className="change-password-form">
                <Row>
                  <Col span={24}>
                    <Field
                      InputType={Input.Password}
                      component={FormInputField}
                      name="old_password"
                      labelText="Old Password"
                      className="text-field"
                      type="password"
                      onChange={onOldPasswordChanged}
                      hideErrorMessage={true}
                      style={{ marginBottom: passwordError && "-20px" }}
                    />
                    {passwordError && (
                      <span
                        style={{
                          color: "red",
                          marginLeft: "5px",
                          marginTop: "20px",
                          display: "block",
                        }}
                      >
                        {passwordError}
                      </span>
                    )}
                    <Field
                      InputType={Input.Password}
                      component={FormInputField}
                      name="password"
                      labelText="New Password"
                      className="text-field"
                      type="password"
                      onChange={onPasswordChanged}
                      hideErrorMessage={true}
                    />
                    <Field
                      InputType={Input.Password}
                      component={FormInputField}
                      name="confirm_password"
                      labelText="Confirm Password"
                      className="text-field"
                      type="password"
                      onChange={onConfirmPasswordChanged}
                      hideErrorMessage={true}
                    />

                    <Col>
                      <Checkbox
                        value={logoutAllDevicesCheckbox}
                        // checked={logoutAllDevicesCheckbox}
                        onChange={() => {
                          setLogoutAllDevicesCheckbox(
                            !logoutAllDevicesCheckbox
                          );
                        }}
                        className="logout-checkbox"
                      >
                        Logout all Devices
                      </Checkbox>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <ul
                      className="password-update-indicators"
                      // style={{ marginLeft: "50%" }}
                    >
                      <li style={{ marginBottom: "10px" }}>
                        {" "}
                        <Checkbox
                          className={
                            validationError?.isMinimumLimitMet
                              ? validatedClassName
                              : inValidatedClassName
                          }
                          checked={true}
                        >
                          Must have at least 8 characters
                        </Checkbox>
                      </li>
                      <li style={{ marginBottom: "10px" }}>
                        {" "}
                        <Checkbox
                          className={
                            validationError?.isOneUpperCharacterLimitMet
                              ? validatedClassName
                              : inValidatedClassName
                          }
                          checked={true}
                        >
                          Must have at least 1 uppercase letter
                        </Checkbox>
                      </li>
                      <li style={{ marginBottom: "10px" }}>
                        {" "}
                        <Checkbox
                          className={
                            validationError?.isOneLowerCharacterLimitMet
                              ? validatedClassName
                              : inValidatedClassName
                          }
                          checked={true}
                        >
                          Must have at least 1 lowercase letter
                        </Checkbox>
                      </li>
                      <li style={{ marginBottom: "10px" }}>
                        {" "}
                        <Checkbox
                          className={
                            validationError?.isOneSpecialCharacterLimitMet
                              ? validatedClassName
                              : inValidatedClassName
                          }
                          checked={true}
                        >
                          Must have at least 1 special character
                        </Checkbox>
                      </li>
                      <li style={{ marginBottom: "10px" }}>
                        {" "}
                        <Checkbox
                          className={
                            validationError?.isOneNumberLimitMet
                              ? validatedClassName
                              : inValidatedClassName
                          }
                          checked={true}
                        >
                          Must have at least 1 number
                        </Checkbox>
                      </li>
                      <li>
                        {" "}
                        <Checkbox
                          className={
                            validationError?.doesPasswordMatch
                              ? validatedClassName
                              : inValidatedClassName
                          }
                          checked={true}
                        >
                          Password and Confirm Password must be same
                        </Checkbox>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </Form>
            </>
          );
        }}
      />
    </>
  );
}

export default ChangePassword;
